// ANALYTICS - TRACKERS //ES6
import { init as initConversion } from './../trackers/product/conversion-tracker';
import { init as initMedia } from './../trackers/product/media-tracker';
import { init as initReview } from './../trackers/product/review-tracker';
import { init as initProductListTracker } from './../trackers/product/product-list-tracker';
import { init as initPanoply } from './../trackers/product/panoply-tracker';
import { init as initAddPanoply } from './../trackers/product/add-panoply-tracker';
import { init as initBackInStock } from './../trackers/product/back-in-stock';
import { init as initProductPage } from './../analytics-product-page';

// // SHOPPING TOOL
import { init as initStTgPush } from './../shopping-tool/st-tg-push';
import { init as initStCarouselCategory } from './../shopping-tool/st-carousel-category';
import { init as initStColorama } from './../shopping-tool/st-colorama';
/// ENHANCED E-COMMERCE
import { init as initEcImprList } from './../enhanced/ec-1-impression-list';
import { init as initEcImprSpotlight } from './../enhanced/ec-1-impression-spotlight';
import { init as initEcExpressCheckout } from './../enhanced/ec-express-checkout';
import { init as initEcAddPanoply } from './../enhanced/ec-add-panoply';
import { init as initEcAddToCart } from './../enhanced/ec-4-add-to-cart';
import { initCatalog as initEcClick } from './../enhanced/ec-2-click';

export const init = () => {
  if (window.cube.config.anly_useLegacy === 'Y') {
    // Initialisation des trackers
    if ($('body').hasClass('product-page')) {
      initConversion();
      initMedia();
      initPanoply();
      initAddPanoply();
      initBackInStock();
      initProductPage();
    }

    if ($('body').hasClass('product-page') || $('body').hasClass('reviews-page'))
      initReview();
    if ($('body').hasClass('listing-page')) initProductListTracker();

    // Init Shopping tools
    initStTgPush();
    initStCarouselCategory();
    initStColorama();

    // Init Enhanced e-Commerce
    initEcImprList();
    initEcImprSpotlight();
    initEcExpressCheckout();
    initEcAddPanoply();
    initEcAddToCart();
    initEcClick();
  }
};



// WEBPACK FOOTER //
// ./src/analytics/routes/catalog.anly.route.js